import { cn } from '@bem-react/classname';

export const cnTag = cn('Tag2');
